import React, { useState } from 'react'
import styles from '../sidebar.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTasks, faBuilding, faChevronDown, faChevronUp, faCircleChevronLeft, faDatabase, faFileAlt, faFileLines, faGripVertical, faHeadphones, faListAlt, faMicrophone, faMicrophoneAlt, faMicrophoneLines, faPlus, faRectangleList, faRightFromBracket, faThLarge, faUsers } from '@fortawesome/free-solid-svg-icons';
import { Collapse } from 'react-bootstrap';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import constant from '../../../../constant';

const Index = ({ isSidebarCollapsed, setIsSidebarCollapsed }) => {
    const [openJobs, setOpenJobs] = useState(false);
    const toggleSidebar = () => {
        setIsSidebarCollapsed(!isSidebarCollapsed);
    };
    return (
        <React.Fragment>
            <div className={`${styles['sidebarn']} sidebarctm ${isSidebarCollapsed ? "collapsed" : ""}`}>
                <div className='d-flex flex-column h-100 sidebar p-3'>
                    <ul className={`${styles['side-nav']} nav flex-column`}>
                        {/* <li className={`nav-item mb-3 ${openJobs ? 'active' : ''}`}>
                            <a href='#' className={`${styles['navc-link']} nav-link d-flex align-items-center`} onClick={() => setOpenJobs(!openJobs)}>
                                <FontAwesomeIcon className='pe-2' icon={faRectangleList} />
                                {!isSidebarCollapsed && <span>Jobs</span>}
                                {!isSidebarCollapsed && <FontAwesomeIcon className='ms-auto' icon={openJobs ? faChevronUp : faChevronDown} />
                                }</a>
                            <Collapse in={openJobs}>
                                <div className="ms-3">
                                    <ul className={`${styles['submenu-ctm']}`}>
                                        <li><a href='#'>Demo First</a></li>
                                        <li><a href='#'>Demo First</a></li>
                                        <li><a href='#'>Demo First</a></li>
                                        <li><a href='#'>Demo First</a></li>
                                    </ul>
                                </div>
                            </Collapse>
                        </li> */}
                        <li className='nav-item mb-3'>
                            <Link to={constant.component.dashboard.url} className={`${styles['navc-link']} nav-link d-flex align-items-center`}>
                                <FontAwesomeIcon className='pe-2' icon={faRectangleList} />
                                {!isSidebarCollapsed && <span>Dashboard</span>}
                            </Link>
                        </li>
                        <li className='nav-item mb-3'>
                            <a href={constant.component.databaseSearch.url} className={`${styles['navc-link']} nav-link d-flex align-items-center`}>
                                <FontAwesomeIcon className='pe-2' icon={faDatabase} />
                                {!isSidebarCollapsed && <span>Database Search</span>}
                            </a>
                        </li>
                        <li className='nav-item mb-3'>
                            <a href={constant.component.UserList.url} className={`${styles['navc-link']} nav-link d-flex align-items-center`}>
                                <FontAwesomeIcon className='pe-2' icon={faUsers} />
                                {!isSidebarCollapsed && <span>Manage Users</span>}
                            </a>
                        </li>
                        <li className='nav-item mb-3'>
                            <a href={constant.component.RecruiterGuidelines.url} className={`${styles['navc-link']} nav-link d-flex align-items-center`}>
                                <FontAwesomeIcon className='pe-2' icon={faGripVertical} />
                                {!isSidebarCollapsed && <span>Recruiter Guidelines</span>}
                            </a>
                        </li>
                        <li className='nav-item mb-3'>
                            <a href='#' className={`${styles['navc-link']} nav-link d-flex align-items-center`}>
                                <FontAwesomeIcon className='pe-2' icon={faBuilding} />
                                {!isSidebarCollapsed && <span>Commercial</span>}
                            </a>
                        </li>
                        <li className='nav-item'>
                            <a href={constant.component.logout.url} className={`${styles['navc-link']} nav-link d-flex align-items-center`}>
                                <FontAwesomeIcon className='pe-2' icon={faRightFromBracket} />
                                {!isSidebarCollapsed && <span>Logout</span>}
                            </a>
                        </li>
                    </ul>
                    {!isSidebarCollapsed && <div className='mt-auto text-center'>
                        <div className='d-flex bg-white align-items-center justify-content-center rounded-2'>
                            <FontAwesomeIcon icon={faHeadphones} className={`${styles['headphone-icon']} pe-2`} />
                            <div className='text-start'>
                                <p className={`${styles['phone-num']} mb-0`}>+91-7353-466-466</p>
                                <p className={`${styles['headphone-text']}`}>Indian Sales Support</p>
                            </div>
                        </div>
                        <p className='mt-2 text-muted fs-7'>© 2023 JobzShala.com Powered by AIPL</p>
                    </div>}
                </div>
                <button onClick={toggleSidebar} className={`${styles['toggle-btn']}`}>

                    <FontAwesomeIcon className={`${styles['toggle-icon']}`} icon={faCircleChevronLeft} />
                </button>
            </div>
        </React.Fragment>
    )
}

export default Index